const groups = [
    {
      id: 1,
      name: 'Bereavement Group',
      href: '/bereavement-group',
      imageSrc: '/pictures/IMG_5097.JPG',
      imageAlt: "Bereavement Group",
    },
    {
      id: 2,
      name: 'Brownies',
      href: '/brownies',
      imageSrc: '/pictures/brownies-logo.jpg',
      imageAlt: "Brownies",
    },
    {
      id: 3,
      name: 'Mother of Mercy Group',
      href: '/mother-of-mercy-group',
      imageSrc: '/pictures/MoM.PNG',
      imageAlt: "Mother of Mercy Group",
    }
  ]


export default function ParishGroupsPage () {
    return(
        <div className="min-h-screen container mx-auto px-4">
            <h1 className="text-3xl font-bold text-center my-6">Parish Groups</h1>
  
            <div className="mb-16 flex flex-col items-center space-y-6 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-12">
              {groups.map((group) => (
                <a
                  key={group.id}
                  href={group.href}
                  className="relative w-60 h-60 rounded-md overflow-hidden group shadow-lg block"
                >
                  {/* Image */}
                  <img
                    src={group.imageSrc}
                    alt={group.imageAlt}
                    className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
                  />

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-white text-lg font-semibold">
                      {group.name || "View"}
                    </span>
                  </div>

                  {/* Title overlayed at the bottom of the card */}
                  <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                    <h3 className="text-sm font-medium text-gray-800">{group.name}</h3>
                  </div>
                </a>
              ))}
            </div>
        </div>
        )
  }